import { content } from "../../config/content.js";
import { buildSectionPill } from "../components/SectionPill.js";

export function createManifestoSection() {
  const { manifesto } = content;
  const section = document.createElement("section");
  section.id = "manifesto";
  section.className = "section manifesto";

  const words = manifesto.paragraph
    .split(/\s+/)
    .map((word, i) => `<span class="manifesto__word" style="--w: ${i}">${word}</span>`)
    .join(" ");

  section.innerHTML = `
    <span class="manifesto__watermark" aria-hidden="true">${manifesto.watermark}</span>
    <div class="section__inner manifesto__inner">
      <span class="reveal">${buildSectionPill(manifesto.badge)}</span>
      <p class="manifesto__paragraph">${words}</p>
      <a class="btn btn--primary manifesto__cta reveal" href="${manifesto.ctaHref}">${manifesto.cta}</a>
    </div>
  `;

  bindScrollHighlight(section);
  return section;
}

function fitWatermarkToViewport(watermark) {
  const viewportWidth = document.documentElement.clientWidth;
  const baseSize = 100;

  watermark.style.fontSize = `${baseSize}px`;
  const measuredWidth = watermark.getBoundingClientRect().width;

  if (measuredWidth > 0) {
    watermark.style.fontSize = `${(viewportWidth / measuredWidth) * baseSize}px`;
  }
}

function positionWatermark(section, watermark, paragraph) {
  const sectionRect = section.getBoundingClientRect();
  const paragraphRect = paragraph.getBoundingClientRect();
  const centerY = paragraphRect.top - sectionRect.top + paragraphRect.height / 2;

  watermark.style.top = `${centerY}px`;
}

/* Scroll-linked text reveal: as the section moves through the viewport,
   words switch from dim to lit, one by one, following scroll position.
   Scrolling back up reverses it. */
function bindScrollHighlight(section) {
  const words = [...section.querySelectorAll(".manifesto__word")];
  const watermark = section.querySelector(".manifesto__watermark");
  const paragraph = section.querySelector(".manifesto__paragraph");
  let ticking = false;

  const update = () => {
    ticking = false;
    const rect = section.getBoundingClientRect();
    const vh = window.innerHeight;

    // 0 when the section top hits 85% of the viewport,
    // 1 when the section bottom reaches 35% — a comfortable reading window
    const start = vh * 0.85;
    const end = vh * 0.35 - rect.height;
    const progress = Math.min(1, Math.max(0, (rect.top - start) / (end - start)));

    const lit = Math.floor(progress * words.length * 1.15);
    words.forEach((word, i) => {
      word.classList.toggle("is-lit", i < lit);
    });

    // Watermark drifts slower than the page for a parallax feel
    watermark.style.transform = `translate(-50%, calc(-50% + ${(0.5 - progress) * 3}rem))`;
  };

  const onScroll = () => {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(update);
    }
  };

  const onResize = () => {
    fitWatermarkToViewport(watermark);
    positionWatermark(section, watermark, paragraph);
    onScroll();
  };

  if (document.fonts?.ready) {
    document.fonts.ready.then(onResize);
  } else {
    onResize();
  }

  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", onResize, { passive: true });
  update();
}
